import { appendBlock } from "@/components/doc/right-sidebar/create-blocks/utils/appendBlock";
import { LABEL_COLORS } from "@/components/graph/labelColors";
import { createNodeFrom } from "@/models/nodes/createNodeFrom";
import { GraphExpressionNodeModel } from "@/models/nodes/GraphExpressionNodeModel";
import { GraphNodeModel } from "@/models/nodes/GraphNodeModel";
import { InlineNodeModel } from "@/models/nodes/InlineNodeModel";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel } from "@/models/nodes/types";
import type { NodeJson } from "@corca/data";

export function insertGraph(
  doc: DocumentModel,
  expressions: (NodeJson | NodeModel)[][],
): GraphNodeModel | null {
  if (expressions.length === 0) {
    return null;
  }

  let graphNode: GraphNodeModel | null = null;

  doc.transact(() => {
    graphNode = doc.batchCreateNodes(() => {
      const graphExpressionNodes = expressions.map((expr, index) => {
        const nodes = expr
          .map((node) => createNodeFrom(node, doc, { resetIds: true }))
          .filter(Boolean);
        const color = LABEL_COLORS[index % LABEL_COLORS.length];

        return doc.create(GraphExpressionNodeModel, { color }, [
          doc.create(InlineNodeModel, nodes),
        ]);
      });

      return doc.create(GraphNodeModel, graphExpressionNodes);
    });

    doc.textNode.appendChild(graphNode);
    appendBlock(doc, "graph", { graphId: graphNode.id });
  }, "insertGraph");

  doc.selection.resetSelection();

  return graphNode;
}
